import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, ListGroup } from 'react-bootstrap';
import NavAnalista from 'components/NavAnalista';
import StatusAnalista from 'components/StatusAnalista';
import MasterPage from 'components/MasterPage';
import { api } from 'services';
import BarChartAnalista from 'components/BarChartAnalista';
import ActionsAnalista from 'components/ActionsAnalista';
import PlansAnalista from 'components/PlansAnalista';
import CategorieGraphic from 'components/DoughnutGraphic/CategorieGraphic';
import VendorGraphic from 'components/DoughnutGraphic/VendorGraphic';
import collect from 'collect.js';

const categoriesArr = [];

const DashboardManager = () => {
  const [funds, setFunds] = useState([]);
  const [marketing, setMarketing] = useState([]);
  const [actions, setActions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [reports, setReports] = useState([]);
  const [companies, setCompanies] = useState({ data: [] });
  const { t } = useTranslation();

  useEffect(() => {
    api
      .get('companies/actual-period', {
        params: { ...{ profile_type_id: '2' } },
      })
      .then(({ data }) => {
        setCompanies(data);
      });
    api.get('get-actions-year').then(({ data }) => {
      setActions(data);
    });
    api.get('get-marketing-plans-year').then(({ data }) => {
      setMarketing(data);
    });
    api.get('get-funds-year').then(({ data }) => {
      setFunds(data);
    });

    api.get('get-expenses-category').then(({ data }) => {
      setCategories(data);
    });

    api.get('companies-funds-actions',{params:{perUser:true}}).then(({ data }) => {
      setReports(data);
    });
  }, []);

  const getCount = (companies, value) => {
    let count = 0;
    companies.data.map((company) => {
      if (company.actual_period.values != null)
        if (Object.values(company.actual_period.values).includes(value)) {
          count++;
        }
    });
    return count;
  };

  const getValue = (companies, value, status) => {
    const estract = (obj, values) => {
      let t = obj;
      values.map((v) => {
        t = t[v];
      });
      return t;
    };
    let total = 0;
    companies.data.map((company) => {
      company.actions.map((action) => {
        if (status == null) {
          total += estract(action, value);
        } else if (status == action.status_id) {
          total += estract(action, value);
        }
      });
    });
    return total;
  };

  const spent = (actions) => {
    let countSpent = 0;
    actions.map((action) => {
      action.all_values.map(
        (value) => {
          let cotacao = value.fund?parseFloat(value.fund.value_cotacao):1;
          countSpent += parseFloat(value.actual_value)*cotacao;
        }
      );
    });
    return countSpent;
  };

  const refunds = (actions) => {
    let countSpent = 0;
    actions.map((action) => {
      action.refunds.map((value) => {
        countSpent += parseFloat(value.value)*action.med_cotacao;
      });
    });
    return countSpent;
  };

  const totalActionValues = (taskGroupId) => {
    let countValue = 0;
    categories.map((action) => {
      action.all_values.map((fund) => {
        if (action.task !== null && action.task.task_group_id === taskGroupId) {
          countValue += fund.actual_value;
        }
      });
    });
    return countValue;
  };

  const createCategories = () => {
    categories.map((action) => {
      if (action.task !== null) {
        let categorie = {
          taskId: action.task_id,
          taskGroupId: action.task.task_group_id,
          categorieName: action.task.task_group.name,
          value: totalActionValues(action.task.task_group_id),
        };
        if (categoriesArr.length === 0) {
          categoriesArr.push(categorie);
        } else if (existCategorie(action.task.task_group_id)) {
          categoriesArr.push(categorie);
        }
      }
    });
  };

  const existCategorie = (taskGroupId) => {
    let flag = true;
    categoriesArr.map((categorie) => {
      if (categorie.taskGroupId === taskGroupId) {
        flag = false;
      }
    });
    return flag;
  };

  const value = (reports) => {
    let arr = [];
    reports.map((report) => {
      let count = 0;
      report.actions.map((action) => {
        action.all_values.map((value) => {
          let cotacao = value.fund?value.fund.value_cotacao:1;
          count += value.actual_value*cotacao;
        });
      });
      arr.push(count);
    });
    return arr;
  };

  const name = (reports) => {
    let arrName = [];
    reports.forEach((report) => {
      arrName.push(report.alias);
    });
    return arrName;
  };
  
  return (
    <>
      <Row>
        <Col>
          <h4>{t('title:dashboard')}</h4>
        </Col>
      </Row>
      <Row>
        <Col>
          <NavAnalista
            countFunds={collect(funds).whereNull('value_real').count()}
            countClaim={collect(actions).where('status_id', 17).count()}
            countPlan={
              collect(marketing).where('status_id', 5).count() +
              collect(marketing).where('status_id', 7).count()
            }
            countExecution={collect(actions).where('status_id', 21).count()}
            countStatus={collect(actions).where('status_id', 13).count()}
            countReceipt={collect(actions).where('status_id', 18).count()}
          />
        </Col>
      </Row>
      <Row>
        <Col className="mt-2">
          <StatusAnalista
            count={collect(actions).pluck('margin').sum('margin')}
            countAwaitingComprovations={spent(
              collect(actions).where('status_id', 13)
            )}
            countAR={spent(collect(actions).where('status_id', 17))}
            countReceipt={spent(collect(actions).where('status_id', 18))}
          />
        </Col>
      </Row>
      <Row>
        <Col className="mt-2 mb-3" xs={6}>
          <ActionsAnalista
            sizeActions={collect(actions).count()}
            countDraft={collect(actions).where('status_id', 5).count()}
            countApproval={collect(actions).where('status_id', 6).count()}
            countDisapproved={collect(actions).where('status_id', 7).count()}
            countAwaitingArts={collect(actions).where('status_id', 9).count()}
            countOnExecution={collect(actions).where('status_id', 21).count()}
            countAwaitingComprovations={collect(actions)
              .where('status_id', 13)
              .count()}
            countComprovationsApproval={collect(actions)
              .where('status_id', 14)
              .count()}
            countDisapprovedComprovations={collect(actions)
              .where('status_id', 15)
              .count()}
            countAwaitingReceipt={collect(actions)
              .where('status_id', 17)
              .count()}
            countFinished={collect(actions).where('status_id', 18).count()}
            countCancelled={collect(actions).where('status_id', 19).count()}
          />
          <Card
            className="shadow bg-white rounded mt-3 mb-3"
            style={{ height: '450px' }}
          >
            <Card.Header>{t('label:spent')}</Card.Header>
            <ListGroup variant="flush">
              <ListGroup.Item>
                {spent(actions).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}{' '}
              </ListGroup.Item>
              <ListGroup.Item className="d-flex flex-row bd-highlight">
                {createCategories()}
                <CategorieGraphic
                  style={{ display: 'block' }}
                  categoriesArr={categoriesArr}
                />
                <VendorGraphic arr={value(reports)} arrName={name(reports)} />
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
        <Col className="mt-2 mb-3" xs={6}>
          <PlansAnalista
            size={collect(marketing).count()}
            countDraftPlan={collect(marketing).where('status_id', 5).count()}
            countPlanApproval={collect(marketing).where('status_id', 6).count()}
            countPlanApproved={collect(marketing).where('status_id', 8).count()}
            countPlanDisapproved={collect(marketing)
              .where('status_id', 7)
              .count()}
            countCustomerApproval={collect(marketing)
              .where('status_id', 20)
              .count()}
            countPlanFinished={collect(marketing)
              .where('status_id', 18)
              .count()}
            countPlanCancelled={collect(marketing)
              .where('status_id', 19)
              .count()}
          />
          <Card
            className="shadow bg-white rounded mt-3 mb-3"
            style={{ height: '450px' }}
          >
            <Card.Header>{t('label:spent')}</Card.Header>
            <BarChartAnalista
              count={collect(funds).sum(a=>{
                return a.current_value*a.value_cotacao;
              })}
              countSpent={spent(actions)}
              countReceipt={refunds(collect(actions).where('status_id', 18))}
              countAR={spent(collect(actions).where('status_id', 17))}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default MasterPage(DashboardManager);
